import { useSelector, useDispatch } from 'react-redux';
import {
  ChevronDownIcon,
  ChevronUpIcon,
  XCloseIcon,
} from '@rsos/base-assets/icons';
import type { AppState } from '../../../../../../../types/AppState';
import { KeywordText } from '../../Keywords/Keywords.styles';
import {
  setSelectedKeywordMatch,
  useSelectedKeywordMatch,
} from '../../transcriptionSlice';
import {
  ClickableIcon,
  KeywordFilterPill,
  KeywordFilterPillCloseButton,
  KeywordFilters,
  TranscriptMatchSortContent,
} from './TranscriptKeywordFilter.styles';

function TranscriptKeywordFilter(): JSX.Element {
  const dispatch = useDispatch();
  const selectedKeywordMatch = useSelectedKeywordMatch();
  const selectedCallerID = useSelector(
    (state: AppState) => state.emergencyCalls.selectedCallerID,
  ) as string;
  const currentIndex = selectedKeywordMatch?.matchIndex;
  const totalMatches = selectedKeywordMatch?.keywordSet.matches.length || 0;

  const handleNextMatch = () => {
    if (
      selectedKeywordMatch &&
      currentIndex !== undefined &&
      currentIndex < totalMatches - 1
    ) {
      dispatch(
        setSelectedKeywordMatch({
          callerId: selectedCallerID,
          match: {
            keywordSetID: selectedKeywordMatch.keywordSet?.keyword_set.id,
            matchIndex: currentIndex + 1,
          },
        }),
      );
    }
  };

  const handlePreviousMatch = () => {
    if (
      selectedKeywordMatch &&
      currentIndex !== undefined &&
      currentIndex > 0
    ) {
      dispatch(
        setSelectedKeywordMatch({
          callerId: selectedCallerID,
          match: {
            keywordSetID: selectedKeywordMatch.keywordSet.keyword_set.id,
            matchIndex: currentIndex - 1,
          },
        }),
      );
    }
  };

  const clearFilter = () => {
    dispatch(
      setSelectedKeywordMatch({
        callerId: selectedCallerID,
        match: null,
      }),
    );
  };

  const hasContent = Boolean(selectedKeywordMatch);

  return (
    <KeywordFilters
      hasContent={hasContent}
      data-name="transcript-keyword-filter"
    >
      {selectedKeywordMatch && (
        <KeywordFilterPill data-name="keyword-filter-pill">
          <KeywordText data-name="keyword-filter-text">
            {selectedKeywordMatch.keywordSet.keyword_set.name}
          </KeywordText>
          <KeywordFilterPillCloseButton onClick={clearFilter}>
            <XCloseIcon color="primaryText" width={10} height={10} />
          </KeywordFilterPillCloseButton>
        </KeywordFilterPill>
      )}
      {selectedKeywordMatch && currentIndex !== undefined && (
        <TranscriptMatchSortContent>
          {currentIndex + 1} / {totalMatches}
          <ClickableIcon
            data-name="keyword-filter-up"
            onClick={handleNextMatch}
          >
            <ChevronDownIcon width={12} height={12} />
          </ClickableIcon>
          <ClickableIcon
            data-name="keyword-filter-down"
            onClick={handlePreviousMatch}
          >
            <ChevronUpIcon width={12} height={12} />
          </ClickableIcon>
        </TranscriptMatchSortContent>
      )}
    </KeywordFilters>
  );
}

export default TranscriptKeywordFilter;
